import $ from 'jquery';

export default() => {
    (function (FooterNav, $) {

        var navAccordianMobile = function navAccordianMobile() {
            var $navAccordianHeading = $('.footer__parent');
            if ($(window).width() < 1024) {
                $navAccordianHeading.on('click', function () {
                    var $sub = $(this).parent().find('.footer__sub');
                    $sub.slideToggle();
                    $sub.toggleClass('hidden');
                    return false;
                });
            } else {
                $navAccordianHeading.off('click');
            }
        };
        FooterNav.init = function () {
            $(window).on('load', function () {
                navAccordianMobile();
            });
            $(window).resize(function () {
                navAccordianMobile();
            });
        };
    })(window.FooterNav = window.FooterNav || {}, $, undefined);
};